import { NotCopiedPrescription, NotCopiedPrescriptionSummaryItem } from './copyPrescription.types';

export const buildNotCopiedSummaryItems = (
   notCopiedPrescriptions: NotCopiedPrescription[],
   medicineNames: ReadonlyMap<number, string>
): NotCopiedPrescriptionSummaryItem[] => {
   const grouped = new Map<number, { medicineId: number; prescriptionIds: number[] }>();

   for (const entry of notCopiedPrescriptions) {
      const existing = grouped.get(entry.medicineId);
      if (existing) {
         existing.prescriptionIds.push(entry.prescriptionId);
      } else {
         grouped.set(entry.medicineId, {
            medicineId: entry.medicineId,
            prescriptionIds: [entry.prescriptionId],
         });
      }
   }

   return [...grouped.values()].map((item) => ({
      medicineId: item.medicineId,
      medicineName: medicineNames.get(item.medicineId) ?? '',
      prescriptionIds: item.prescriptionIds,
      count: item.prescriptionIds.length,
      replaced: false,
   }));
};
